import { AnalyticsTable } from '@cartrack-crm/ui'
export default AnalyticsTable
